import type { ThemeWithoutTokens } from '../theme.types';

export const gridTokens = (theme: ThemeWithoutTokens) =>
  ({
    gridGapX: theme.space.component.x.m,
    gridGapY: theme.space.component.x.m,
    gridWrapperPaddingX: theme.space.component.x.l,
  }) as const;
